import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { TextAreaField } from "../formElements/TextAreaField";
import SuccessModal from "../Modal/supplier_app/SuccessModal";

const CancelModal = React.forwardRef((props, ref) => {
  const {
    type,
    selectedrow,
    title,
    onConfirm,
    docKey = "documentNumber",
  } = props;

  const [formInputs, setFormInputs] = useState({
    documentNumbers: [],
    cancellationRemark: "",
  });

  const [errorMsg, setErrorMsg] = useState("");

  // ✅ Helper to reset form
  const resetForm = () => {
    setFormInputs((prev) => ({ ...prev, cancellationRemark: "" }));
    setErrorMsg("");
  };

  // ✅ Reset when modal opens
  useEffect(() => {
    if (props.show) {
      resetForm();
    }
  }, [props.show]); // eslint-disable-line react-hooks/exhaustive-deps

  /* 🔄 Set document numbers from selected rows */
  useEffect(() => {
    const docs =
      selectedrow?.map((item) => item?.[docKey])?.filter(Boolean) || [];
    setFormInputs((prev) => ({
      ...prev,
      documentNumbers: docs,
    }));
  }, [selectedrow, docKey]);

  /* ✅ Success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState({
    title: "Message",
    successMsg: "",
  });

  const handleSubmit = async () => {
    if (!formInputs.cancellationRemark.trim()) {
      setErrorMsg("*Please enter the remarks");
      return;
    }

    setErrorMsg("");

    const payload = {
      module: type,
      documentNumber: formInputs.documentNumbers,
      status: "Cancelled",
      cancellationRemark: formInputs.cancellationRemark,
    };

    try {
      const res = await onConfirm(payload);

      if (res?.status === 200) {
        setsucceModalData({
          title: "Message",
          successMsg: res.message,
        });
        setShowSuccessModal(true);
        resetForm(); // ✅ clear after successful submit too
        props.onHide();

        if (props.onSuccess) props.onSuccess();
      }
    } catch (err) {
      console.error("Cancel Error:", err);
    }
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <Modal {...props} centered size="lg" ref={ref} keyboard={false}>
        {/* 🔵 HEADER */}
        <Modal.Header
          style={{
            backgroundColor: "#7fa2cc",
            color: "#fff",
            borderBottom: "none",
          }}
        >
          <Modal.Title>
            <i className="bi bi-plus-lg me-2"></i> {title}
          </Modal.Title>
        </Modal.Header>

        {/* 🧾 BODY */}
        <Modal.Body style={{ padding: "25px 30px" }}>
          <form>
            <Row>
              <Col xs={12}>
                <p style={{ fontSize: "16px", fontWeight: 500, color: "#333" }}>
                  Do you want to cancel the {type?.toUpperCase()} Number?
                </p>

                {/* 🟢 DOCUMENT NUMBER BADGES */}
                <Row>
                  {formInputs.documentNumbers.length > 0 ? (
                    formInputs.documentNumbers.map((item, index) => (
                      <Col xs="auto" key={index}>
                        <p
                          style={{
                            backgroundColor: "#c8ead6",
                            color: "#1f7a4d",
                            padding: "8px 16px",
                            borderRadius: "20px",
                            fontWeight: "600",
                            display: "inline-block",
                            marginBottom: "10px",
                          }}
                        >
                          {item}
                        </p>
                      </Col>
                    ))
                  ) : (
                    <p style={{ color: "red" }}>No Document Found</p>
                  )}
                </Row>

                {/* 📝 REMARK TEXTAREA */}
                <TextAreaField
                  className="inputBox"
                  style={{
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    padding: "12px",
                    marginTop: "10px",
                  }}
                  name="cancellationRemark"
                  placeholder={`Please enter the ${type?.toUpperCase()} remark`}
                  value={formInputs.cancellationRemark}
                  onChange={onInputChange}
                />
              </Col>
            </Row>

            {/* 🔘 NO / YES BUTTONS */}
            <Row
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "15px",
                marginTop: "20px",
              }}
            >
              <Col xs="auto">
                {/* ✅ FIXED: resetForm on No click */}
                <button
                  type="button"
                  onClick={() => {
                    resetForm();
                    props.onHide();
                  }}
                  style={{
                    backgroundColor: "#e74c57",
                    color: "#fff",
                    border: "none",
                    padding: "10px 40px",
                    borderRadius: "8px",
                    fontWeight: "500",
                  }}
                >
                  No
                </button>
              </Col>
              <Col xs="auto">
                <button
                  type="button"
                  onClick={handleSubmit}
                  style={{
                    backgroundColor: "#8fb3d9",
                    color: "#000",
                    border: "none",
                    padding: "10px 40px",
                    borderRadius: "8px",
                    fontWeight: "500",
                  }}
                >
                  Yes
                </button>
              </Col>
            </Row>

            {/* ❌ ERROR MESSAGE */}
            {errorMsg && (
              <p style={{ color: "red", marginTop: "10px" }}>{errorMsg}</p>
            )}
          </form>
        </Modal.Body>
      </Modal>

      {/* ✅ SUCCESS MODAL */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successmodaldata={getsucceModalData}
      />
    </>
  );
});

export default CancelModal;